<kilowant-header [isBuyer]="true" [showAccountList]="false" title="Price Plans"></kilowant-header>
<div class="wrapperMain mainAccountDetailsMain accountDetails">
    @if (pageLoaded()) {
    <div class="form buyer">
        @if (companyFilter()) {
        <div class="mt-10 mb-10 d-flex">
            <select name="filterCompany" style="width: 100%" class="grey-select f14" [compareWith]="compareFn" [(ngModel)]="selectedFilterCompany" (change)="reloadFilterAccounts()">
                <option value="all">{{getNameForAll()}}</option>
                @for (company of userCompanies; track company) {
                <option [ngValue]="company">{{getUserCompanyName(company)}}</option>
                }
            </select>
        </div>
        }
        <div class="mt-10 mb-10 d-flex">
            <select name="filterAccount" style="width: 100%" class="grey-select f14" [compareWith]="compareFn" [(ngModel)]="selectedFilterAccount" (change)="reloadKilowantContracts()">
                <option value="null">All accounts</option>
                @for (account of userAccounts; track account) {
                <option [ngValue]="account">{{account.name}} {{account.utilityInfo}}</option>
                }
            </select>
        </div>
        <mat-tab-group mat-align-tabs="start" #tabs [(selectedIndex)]="tabIndex" class="contractsHeader" (selectedTabChange)="tabChanged($event)">
            <mat-tab label="Pending">
                @if ((pendingContracts==null || pendingContracts.length==0)) {
                <div class="info-text"> There are no pending price plans. </div>
                }
                @if ((pendingContracts!=null && pendingContracts.length>0)) {
                <div>
                    <table #pendingContractTable="matSort"
                           mat-table
                           matSort
                           (matSortChange)="sortDataEvent($event)"
                           [dataSource]="pendingContractsSorted"
                           matSortActive="ServiceStart"
                           matSortDisableClear="true"
                           matSortDirection="asc"
                           class="offer-summmary-table in-card-table background-transparent"
                           multiTemplateDataRows>
                        <ng-container matColumnDef="SupplierName">
                            <td mat-cell
                                *matCellDef="let kilowantContract; let i = dataIndex;"
                                class="no-border cursor-pointer"
                                style="text-align: left"
                                [attr.colspan]="displayedColumns.length">
                                {{$any(kilowantContract.value).supplierName}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                &nbsp;&nbsp;
                            </th>
                            <td mat-cell
                                *matCellDef="let kilowantContract; let i = dataIndex;"
                                class="text-center">
                                {{currentStart+i+1}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Price">
                            <th mat-header-cell *matHeaderCellDef>$/kWh</th>
                            <td mat-cell
                                *matCellDef="let kilowantContract"
                                class="cursor-pointer long-text-cut">
                                {{$any(kilowantContract.value).getSalesPrice() | currency:'USD':'symbol':'1.5-5'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="ServiceStart">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Service Start
                            </th>
                            <td mat-cell
                                *matCellDef="let kilowantContract"
                                class="cursor-pointer long-text-cut">
                                {{$any(kilowantContract.value).termFrom | date:'shortDate'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="ServiceEnd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Service End</th>
                            <td mat-cell
                                *matCellDef="let kilowantContract"
                                class="cursor-pointer long-text-cut">
                                {{$any(kilowantContract.value).termTo | date:'shortDate'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="DateEntered">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Offer Date</th>
                            <td mat-cell
                                *matCellDef="let kilowantContract"
                                class="cursor-pointer long-text-cut">
                                {{$any(kilowantContract.value).dateEntered | date:'shortDate'}}
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row
                            *matRowDef="let kilowantContract; let i = dataIndex; columns: ['SupplierName']"
                            [class]="(i==editModePos)?'selected':''+' frow'"
                            (click)="(kilowantContract.key)?viewContract($any(kilowantContract.value), true):viewContract($any(kilowantContract.value), false)"></tr>
                        <tr mat-row
                            *matRowDef="let kilowantContract; let i = dataIndex; let row; columns: displayedColumns;"
                            (click)="(kilowantContract.key)?viewContract($any(kilowantContract.value), true):viewContract($any(kilowantContract.value), false)"
                            [class]="(i==editModePos)?'selected':''+' srow'"></tr>
                    </table>
                </div>
                }
            </mat-tab>
            <mat-tab label="Open">
                @if ((openContracts==null || openContracts.length==0)) {
                <div class="info-text"> There are no open price plans. </div>
                }
                @if ((openContracts!=null && openContracts.length>0)) {
                <div>
                    <table #openContractTable="matSort"
                           mat-table
                           matSort
                           (matSortChange)="sortDataEvent($event)"
                           [dataSource]="openContractsSorted"
                           matSortActive="SupplierName"
                           matSortDisableClear="true"
                           matSortDirection="asc"
                           class="offer-summmary-table in-card-table background-transparent"
                           multiTemplateDataRows>
                        <ng-container matColumnDef="SupplierName">
                            <td mat-cell
                                *matCellDef="let kilowantContract; let i = dataIndex;"
                                class="no-border cursor-pointer"
                                style="text-align: left"
                                [attr.colspan]="displayedColumns.length">
                                {{$any(kilowantContract.value).supplierName}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                &nbsp;&nbsp;
                            </th>
                            <td mat-cell
                                *matCellDef="let kilowantContract; let i = dataIndex;"
                                class="text-center">
                                {{currentStart+i+1}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Price">
                            <th mat-header-cell *matHeaderCellDef>$/kWh</th>
                            <td mat-cell
                                *matCellDef="let kilowantContract"
                                class="cursor-pointer long-text-cut">
                                {{$any(kilowantContract.value).getSalesPrice() | currency:'USD':'symbol':'1.5-5'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="ServiceStart">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Service Start
                            </th>
                            <td mat-cell
                                *matCellDef="let kilowantContract"
                                class="cursor-pointer long-text-cut">
                                {{$any(kilowantContract.value).termFrom | date:'shortDate'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="ServiceEnd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Service End</th>
                            <td mat-cell
                                *matCellDef="let kilowantContract"
                                class="cursor-pointer long-text-cut">
                                {{$any(kilowantContract.value).termTo | date:'shortDate'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="DateEntered">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Offer Date</th>
                            <td mat-cell
                                *matCellDef="let kilowantContract"
                                class="cursor-pointer long-text-cut">
                                {{$any(kilowantContract.value).dateEntered | date:'shortDate'}}
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row
                            *matRowDef="let kilowantContract; let i = dataIndex; columns: ['SupplierName']"
                            [class]="(i==editModePos)?'selected':''+' frow'"
                            (click)="(kilowantContract.key)?viewContract($any(kilowantContract.value), true):viewContract($any(kilowantContract.value), false)"></tr>
                        <tr mat-row
                            *matRowDef="let kilowantContract; let i = dataIndex; let row; columns: displayedColumns;"
                            (click)="(kilowantContract.key)?viewContract($any(kilowantContract.value), true):viewContract($any(kilowantContract.value), false)"
                            [class]="(i==editModePos)?'selected':''+' srow'"></tr>
                    </table>
                </div>
                }
            </mat-tab>
            <mat-tab label="Closed">
                @if ((closedContracts==null || closedContracts.length==0)) {
                <div class="info-text"> There are no closed price plans. </div>
                }
                @if ((closedContracts!=null && closedContracts.length>0)) {
                <table #closedContractTable="matSort"
                       mat-table
                       matSort
                       (matSortChange)="sortDataEvent($event)"
                       [dataSource]="closedContractsSorted"
                       matSortActive="SupplierName"
                       matSortDisableClear="true"
                       matSortDirection="asc"
                       class="offer-summmary-table in-card-table background-transparent"
                       multiTemplateDataRows>
                    <ng-container matColumnDef="SupplierName">
                        <td mat-cell
                            *matCellDef="let kilowantContract; let i = dataIndex;"
                            class="no-border cursor-pointer"
                            style="text-align: left"
                            [attr.colspan]="displayedColumns.length">
                            {{$any(kilowantContract.value).supplierName}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef class="text-center">
                            &nbsp;&nbsp;
                        </th>
                        <td mat-cell
                            *matCellDef="let kilowantContract; let i = dataIndex;"
                            class="text-center">
                            {{currentStart+i+1}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Price">
                        <th mat-header-cell *matHeaderCellDef>$/kWh</th>
                        <td mat-cell
                            *matCellDef="let kilowantContract"
                            class="cursor-pointer long-text-cut">
                            {{$any(kilowantContract.value).getSalesPrice() | currency:'USD':'symbol':'1.5-5'}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ServiceStart">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Service Start
                        </th>
                        <td mat-cell
                            *matCellDef="let kilowantContract"
                            class="cursor-pointer long-text-cut">
                            {{$any(kilowantContract.value).termFrom | date:'shortDate'}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ServiceEnd">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Service End</th>
                        <td mat-cell
                            *matCellDef="let kilowantContract"
                            class="cursor-pointer long-text-cut">
                            {{$any(kilowantContract.value).termTo | date:'shortDate'}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="DateEntered">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Offer Date</th>
                        <td mat-cell
                            *matCellDef="let kilowantContract"
                            class="cursor-pointer long-text-cut">
                            {{$any(kilowantContract.value).dateEntered | date:'shortDate'}}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row
                        *matRowDef="let kilowantContract; let i = dataIndex; columns: ['SupplierName']"
                        [class]="(i==editModePos)?'selected':((isViewContractActive($any(kilowantContract.value).status))?'':'inactive')+' frow'"
                        (click)="(kilowantContract.key)?viewContract($any(kilowantContract.value), true):viewContract($any(kilowantContract.value), false)"></tr>
                    <tr mat-row
                        *matRowDef="let kilowantContract; let i = dataIndex; let row; columns: displayedColumns;"
                        (click)="(kilowantContract.key)?viewContract($any(kilowantContract.value), true):viewContract($any(kilowantContract.value), false)"
                        [class]="(i==editModePos)?'selected':((isViewContractActive($any(kilowantContract.value).status))?'':'inactive')+' srow'"></tr>

                </table>
                @if (hasClosedContracts) {
                <div class="utility-chart-info inactive">* Price Plan Rescinded</div>
                }
                }
            </mat-tab>
        </mat-tab-group>
        <div class="block-buttons under-card mt-20">
            <button type="button" (click)="addExistingContract()">Add Price Plan</button>
        </div>
    </div>
    }
      </div>
